import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import {
  DEFAULT_LANGUAGE,
  LANGUAGES,
  SUPPORTED_LANGUAGES,
} from "./languages";

export { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./languages";
export const LANGUAGE_STORAGE_KEY = "makemake_language";

export const normalizeLanguage = (language) => {
  const normalizedLanguage = String(language || "")
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_LANGUAGES.includes(normalizedLanguage)
    ? normalizedLanguage
    : DEFAULT_LANGUAGE;
};

const getSupportedLanguage = (language) => {
  const normalizedLanguage = String(language || "")
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_LANGUAGES.includes(normalizedLanguage)
    ? normalizedLanguage
    : null;
};

export const getInitialLanguage = () => {
  try {
    const savedLanguage = getSupportedLanguage(
      localStorage.getItem(LANGUAGE_STORAGE_KEY)
    );

    if (savedLanguage) {
      return savedLanguage;
    }
  } catch {
    // Continue with the browser language when storage is unavailable.
  }

  if (typeof navigator !== "undefined") {
    const browserLanguages = [
      ...(navigator.languages || []),
      navigator.language,
    ];
    const browserLanguage = browserLanguages
      .map(getSupportedLanguage)
      .find(Boolean);

    if (browserLanguage) {
      return browserLanguage;
    }
  }

  return DEFAULT_LANGUAGE;
};

const resources = Object.fromEntries(
  LANGUAGES.map(({ id, translations }) => [
    id,
    { translation: translations },
  ])
);

const updateLanguagePreference = (language) => {
  const normalizedLanguage = normalizeLanguage(language);

  document.documentElement.lang = normalizedLanguage;

  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
  } catch {
    // The language remains active even if browser storage is unavailable.
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on("languageChanged", updateLanguagePreference);
updateLanguagePreference(i18n.resolvedLanguage || i18n.language);

export default i18n;
